import type { Api } from '@automapa/svelte-automapa-template';
import { z } from 'zod';

/*
'params' => [
                'icon' => 'LAYERS_ICON.heat',
                'legend' => [
                    [
                        'zmin' => 0,
                        'zmax' => 29,
                        'vmin' => 0,
                        'vmax' => 5000000,
                        'f' => [
                            ['c' => '#FFFFB2', 'v' => '0 - 50000'],
                            ['c' => '#FED976', 'v' => '50000 - 100000'],
                            ['c' => '#FEB24C', 'v' => '100000 - 250000'],
                            ['c' => '#FD8D3C', 'v' => '250000 - 500000'],
                            ['c' => '#FC4E2A', 'v' => '500000 - 1000000'],
                            ['c' => '#E31A1C', 'v' => '1000000 - 2500000'],
                            ['c' => '#B10026', 'v' => '2500000 - 5000000']
                        ]
                    ]
                ]
            ]
 */
export const MapLayerOneSchema = z.object({
    id: z.string(),
    label: z.string().catch('layer-default-label'),
    tile_url: z.string().catch('layer-without-tile-url'),
    visible: z.boolean().catch(false),
    available: z.boolean(),
    z_index: z.number().catch(10),
    opacity: z.number().catch(0.7),
    priority: z.number().catch(10),
    maxtries: z.number().catch(3),
    enabled: z.boolean().catch(false),
    params: z
        .union([
            z.object({
                icon: z.string().describe("icon name, ex. 'LAYERS_ICON.heat'"),
                legend: z.array(
                    z.object({
                        zmin: z.number().describe('minimum zoom to display this legend'),
                        zmax: z.number().describe('maximum zoom to display this legend'),
                        vmin: z.coerce.string().describe('15min'),
                        vmax: z.coerce.string().describe('1h'),
                        f: z.array(
                            z.object({
                                c: z.string().describe('color in hex #334455'),
                                v: z.string().describe('value range (visible on hover)'),
                            })
                        ),
                    })
                ),
            }),
            z.array(z.any()).length(0),
        ])
        .transform(val => {
            return Array.isArray(val) ? null : val; // support empty []
        })
        .nullable(),
});
export type MapLayerOneType = z.infer<typeof MapLayerOneSchema>;

export class MapLayerApi {
    private api: Api;

    constructor(api: Api) {
        this.api = api;
    }

    async getAvailable(): Promise<MapLayerOneType[]> {
        return this.api.getData(
            'get',
            '/map_layer/get_available_map_layers',
            undefined,
            z.undefined(),
            z.array(MapLayerOneSchema)
        );
    }

    async getAll(): Promise<MapLayerOneType[]> {
        return this.api.getData(
            'get',
            '/map_layer/get_all_map_layers',
            undefined,
            z.undefined(),
            z.array(MapLayerOneSchema)
        );
    }
}
